export const CELL_SIZE = 80;
export const GRID_PADDING = 8;

// These type shapes define the fixed seat layout shown inside the section modal.
// They are intentionally used for seat-slot rendering, independent of the
// section card dimensions used on the main floor layout.
export const SECTION_OPTIONS = [
  {
    value: "rectangle",
    label: "Bay",
    width: 6,
    height: 2,
    className: "bg-[#e2f2e9] border-[#a8d5ba] text-[#1a5336]",
    selectedColor: "#1a5336",
    badge: "RECTANGLE",
  },
  {
    value: "cubicle",
    label: "Cubicle",
    width: 3,
    height: 2,
    className: "bg-[#f4f7e2] border-[#d8e0a8] text-[#53531a]",
    selectedColor: "#53531a",
    badge: "CUBICLE",
  },
  {
    value: "cabin",
    label: "Cabin",
    width: 1,
    height: 1,
    className: "bg-[#f7e2e2] border-[#e0a8a8] text-[#531a1a]",
    selectedColor: "#531a1a",
    badge: "CABIN",
  },
  {
    value: "conference",
    label: "Conference Room",
    width: 4,
    height: 3,
    className: "bg-[#e2e8f7] border-[#a8b8e0] text-[#1a2a53]",
    selectedColor: "#1a2a53",
    badge: "CONFERENCE",
  },
];

export const OFFICE_THEMES = [
  { className: "bg-[#e2f2e9] border-[#a8d5ba] text-[#1a5336]", selectedColor: "#1a5336", badge: "RECTANGLE" },
  { className: "bg-[#f4f7e2] border-[#d8e0a8] text-[#53531a]", selectedColor: "#53531a", badge: "CUBICLE" },
  { className: "bg-[#e2f0f7] border-[#a8d0e0] text-[#1a4453]", selectedColor: "#1a4453", badge: "RECTANGLE" },
  { className: "bg-[#f7e2e2] border-[#e0a8a8] text-[#531a1a]", selectedColor: "#531a1a", badge: "CABIN" },
  { className: "bg-[#e9e2f7] border-[#bba8e0] text-[#2c1a53]", selectedColor: "#2c1a53", badge: "RECTANGLE" },
  { className: "bg-[#fdf0e6] border-[#f4c8a8] text-[#7a3e1a]", selectedColor: "#7a3e1a", badge: "CABIN" },
  { className: "bg-[#e2e8f7] border-[#a8b8e0] text-[#1a2a53]", selectedColor: "#1a2a53", badge: "CONFERENCE" },
];

export const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const BOOKING_MODES = [
  { value: "specific", label: "Specific Dates" },
  { value: "range", label: "Date Range" },
  { value: "recurring", label: "Recurring" },
  { value: "permanent", label: "Permanent" },
];
